import { CarsState } from "./state.js";
import { applyCarsFilters } from "./filters.js";

export function initCarsSearch() {
  const dom = CarsState.dom;
  if (!dom || !dom.searchInput) return;

  dom.searchInput.addEventListener("input", function () {
    window.clearTimeout(dom.searchInput.__t);
    dom.searchInput.__t = window.setTimeout(applyCarsFilters, 120);
  });
}